import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-756af980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgrnd" }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "general" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Dashboard", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "embeddingContainer" }, null, -1))
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = {
  key: 0,
  class: "card bg-secondary"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bold" }, "Cantidad de Mejoras por Estatus", -1))
const _hoisted_12 = { id: "customers" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Estatus"),
  /*#__PURE__*/_createElementVNode("th", null, "Cantidad")
], -1))
const _hoisted_14 = { class: "der" }
const _hoisted_15 = {
  key: 1,
  class: "card bg-secondary"
}
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bold" }, "Cantidad de Usuarios por Rol", -1))
const _hoisted_18 = { id: "customers" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Estatus"),
  /*#__PURE__*/_createElementVNode("th", null, "Cantidad")
], -1))
const _hoisted_20 = { class: "der" }
const _hoisted_21 = {
  key: 2,
  class: "card bg-secondary"
}
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bold" }, "Facturación a Fundación por Período", -1))
const _hoisted_24 = { id: "customers" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Período"),
  /*#__PURE__*/_createElementVNode("th", null, "Servicios"),
  /*#__PURE__*/_createElementVNode("th", null, "Facturado"),
  /*#__PURE__*/_createElementVNode("th", null, "Disponible")
], -1))
const _hoisted_26 = { class: "der" }
const _hoisted_27 = { class: "der" }
const _hoisted_28 = {
  key: 3,
  class: "card bg-secondary"
}
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bold" }, " Facturación a Senasa Subsidiado por Período ", -1))
const _hoisted_32 = { id: "customers" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Período"),
  /*#__PURE__*/_createElementVNode("th", null, "Servicios"),
  /*#__PURE__*/_createElementVNode("th", null, "Facturado"),
  /*#__PURE__*/_createElementVNode("th", null, "Disponible")
], -1))
const _hoisted_34 = { class: "der" }
const _hoisted_35 = { class: "der" }
const _hoisted_36 = {
  key: 4,
  class: "card bg-secondary"
}
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bold" }, " Registro de Productos por Día ", -1))
const _hoisted_39 = { id: "customers" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Día"),
  /*#__PURE__*/_createElementVNode("th", null, "Productos")
], -1))
const _hoisted_41 = { class: "der" }
const _hoisted_42 = { class: "der" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (this.$store.state.user.type == 'Power User')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("table", _hoisted_12, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mejorasPend, (tipoMejora, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(tipoMejora._id.estatus), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString($options.formatNumber(tipoMejora.count, false)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (this.$store.state.user.type == 'Power User')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("table", _hoisted_18, [
                    _hoisted_19,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.usuariosCant, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item._id.role), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString($options.formatNumber(item.count, false)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
            this.$store.state.user.type == 'Director Médico' ||
              this.$store.state.user.type == 'Encargado'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _createElementVNode("table", _hoisted_24, [
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodos, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString($options.getMonth(item._id.month)), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString($options.formatNumber(item.count, false)), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString($options.formatNumber(item.cobertura, true)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass($options.formatTable(this.presupuesto - item.cobertura))
                        }, _toDisplayString($options.formatNumber(this.presupuesto - item.cobertura, true)), 3)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
            this.$store.state.user.type == 'Director Médico' ||

              this.$store.state.user.type == 'Encargado'
          )
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (
                this.$store.state.user.type == 'Power User' ||
                this.$store.state.user.type == 'Director Médico' ||

                  this.$store.state.user.type == 'Encargado'
                  
              )
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("table", _hoisted_32, [
                        _hoisted_33,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodos2, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString($options.getMonth(item._id.month)), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString($options.formatNumber(item.count, false)), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString($options.formatNumber(item.cobertura, true)), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass($options.formatTable(this.presupuesto2 - item.cobertura))
                            }, _toDisplayString($options.formatNumber(this.presupuesto2 - item.cobertura, true)), 3)
                          ]))
                        }), 128))
                      ])
                    ], 512)), [
                      [_vShow, !$data.cargando]
                    ])
                  : _createCommentVNode("", true)
              ])
            ], 512)), [
              [_vShow, !$data.cargando]
            ])
          : _createCommentVNode("", true),
        (
            this.$store.state.user.type == 'Power User' ||
              this.$store.state.user.type == 'Encargado' ||
              this.$store.state.user.type == 'Administrador'
          )
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  _hoisted_38,
                  _createElementVNode("table", _hoisted_39, [
                    _hoisted_40,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dias, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item._id.day), 1),
                        _createElementVNode("td", _hoisted_41, _toDisplayString($options.formatNumber(item.count, false)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, "Total: " + _toDisplayString($options.formatNumber(this.totales.dias, false)), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString($options.formatNumber(this.totales.cantProductos, false)), 1)
                    ])
                  ])
                ])
              ])
            ], 512)), [
              [_vShow, !$data.cargando]
            ])
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}